import React, { useContext, useEffect, useState } from "react";
import instructionImg from "../assets/instruction.png";
import logo from "../assets/companyLogo.png";
import { useLocation, useNavigate } from "react-router-dom";
import {
  LanguageContext,
  SET_ATTEMPT_ID,
  SET_LANGUAGE,
  SET_TEMPLATE_CODE,
} from "../contexts/LanguageContext";
import axios from "axios";
import Swal from "sweetalert2";

const InstructionPage = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [attemptData, setAttemptData] = useState({
    attemptId: "",
    templateCode: "",
    time_limit: "",
  });
  const [isDefault, setIsDefault] = useState(false);
  const [isAttemptSuccess, setIsAttemptSuccess] = useState(false);
  const { dispatch } = useContext(LanguageContext);
  let tmpCode = location.state.template_code;
  const instructions = [
    "Only one attempt is allowed per participant.",
    "Choose one right answer from the options.",
    "50 Questions to be answered in 30 Mins.",
    "Click Submit upon completion to know your score.",
    "Selection Pass mark is 70%",
  ];
  useEffect(() => {
    dispatch({ type: SET_TEMPLATE_CODE, payload: { tmpCode } });

    handleAttempt(location.state.language);
  }, []);
  const handleAttempt = async (lang) => {
    console.log(lang);
    if (!lang) return;

    dispatch({ type: SET_LANGUAGE, payload: { language: lang } });

    try {
      const res = await axios.post(`${process.env.REACT_APP_API_URL}/attempt`, {
        template_code: tmpCode,
        language_code: lang.code,
        user_id: location.state.user_id,
      });
      if (res.data.success) {
        const attempt = res.data.payload;

        setIsAttemptSuccess(true);

        dispatch({
          type: SET_ATTEMPT_ID,
          payload: { attemptId: attempt.id },
        });

        if (attempt.status === "Open") {
          setAttemptData({
            attemptId: attempt.id,
            templateCode: tmpCode,
            time_limit: attempt.time_limit,
          });
        } else {
          navigate(`/score/${attempt.id}/${tmpCode}`);
        }
      } else {
        setIsAttemptSuccess(false);
      }
    } catch (err) {
      Swal.fire({
        title: err?.response?.data?.payload?.message || "Error",
        icon: "error",
      });
    }
  };
  const handleContinue = () => {
    console.log(attemptData);
    navigate(`/questions/${attemptData.attemptId}/${tmpCode}`, {
      state: {
        time_limit: attemptData.time_limit,
      },
    });
  };
  const isQuizEnabled = isDefault && isAttemptSuccess;
  return (
    <div className="min-h-screen bg-[white] flex items-center justify-center p-1">
      <div className="w-full max-w-[1400px] bg-[#F5F5F5] rounded-[24px] overflow-hidden flex flex-col lg:flex-row shadow-md">
        <div
          className="relative w-full lg:w-[40%] min-h-[250px] lg:min-h-[700px] flex items-center justify-center overflow-hidden rounded-b-[40px] lg:rounded-b-none lg:rounded-r-[60px]"
          style={{
            background: "linear-gradient(180deg, #F7E9CB 0%, #F5A400 100%)",
          }}
        >
          <div className="absolute inset-0 opacity-20 bg-[radial-gradient(#fff_1px,transparent_1px)] [background-size:24px_24px]" />

          <img
            src={instructionImg}
            alt="instruction"
            className="relative z-10 w-[70%] sm:w-[55%] lg:w-[80%] object-contain"
          />
        </div>

        <div className="relative w-full lg:w-[60%] flex flex-col justify-center px-6 sm:px-10 lg:px-20 py-10 lg:py-16">
          <img src={logo} alt="logo" className="w-[180px] mb-10" />

          <div className="mb-8">
            <h2 className="text-[22px] text-[#2B2B2B] font-medium">
              Few Instructions
            </h2>

            <h1 className="text-[42px] leading-[50px] font-semibold text-[#2B2B2B]">
              Before You{" "}
              <span className="text-[#F5A400] font-medium">Begin</span>
            </h1>
          </div>

          <ol className="list-decimal pl-6 space-y-3 text-[18px] leading-[34px] text-[#1F1F1F] max-w-[600px]">
            {instructions.map((item, index) => (
              <li key={index}>{item}</li>
            ))}
          </ol>
          <div className="mt-4">
            <label className="flex items-start gap-2 text-sm text-gray-600 mt-2">
              <label className="flex items-center cursor-pointer">
                <input
                  type="checkbox"
                  checked={isDefault}
                  onChange={() => setIsDefault(!isDefault)}
                  className="hidden"
                />

                <div
                  className={`w-5 h-5 rounded border flex items-center justify-center ${
                    isDefault
                      ? "bg-[#f7a600] border-[#f7a600]"
                      : "bg-white border-gray-400"
                  }`}
                >
                  {isDefault && (
                    <span className="text-white text-xs font-bold">✓</span>
                  )}
                </div>
              </label>

              <span>
                I agree to the Terms & Conditions before starting the quiz
              </span>
            </label>
          </div>

          <div>
            <button
              onClick={handleContinue}
              disabled={!isQuizEnabled}
              type="submit"
              style={{
                ...styles.button,
                ...(!isQuizEnabled ? styles.disabledBtn : {}),
              }}
            >
              Start Quiz<span style={styles.arrow}>→</span>
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default InstructionPage;
const styles = {
  button: {
    width: "100%",
    minHeight: "58px",
    border: "none",
    borderRadius: "14px",

    backgroundColor: "#f7a600",
    color: "#ffffff",

    fontSize: "clamp(15px, 2vw, 17px)",
    fontWeight: 600,

    cursor: "pointer",

    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    gap: "10px",

    marginTop: "30px",

    transition: "all 0.2s ease",

    padding: "14px 20px",
  },
  disabledBtn: {
    backgroundColor: "#BDBDBD",
    cursor: "not-allowed",
    opacity: 0.7,
  },
};
